import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { BiBook } from "react-icons/bi";
import { GiBookshelf } from "react-icons/gi";
import { AiOutlineUser, AiOutlineTags } from "react-icons/ai";
import { FiUsers, FiSettings } from "react-icons/fi";
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarRightCollapse } from "react-icons/tb";
import { Layout, Menu } from 'antd';
import { useSelector } from 'react-redux';
import settingSelectors from 'src/redux/selectors/settingSelectors';
import { adjustColor } from 'src/utils/helpers';

const { Sider } = Layout;

const CustomSider = () => {
  const navigate = useNavigate();
  const [siderCollapsed, setSiderCollapsed] = useState(false);
  const themeColor = useSelector(settingSelectors.themeColor);

  const toggleSider = () => {
    setSiderCollapsed(!siderCollapsed);
  };

  const items = [
    {
      key: 'comic',
      label: <span style={{ color: 'white', fontSize: 16 }}>Comic</span>,
      icon: <BiBook style={{ color: 'white', fontSize: 20 }} />,
      children: [
        {
          key: 'comics',
          icon: <GiBookshelf style={{ color: 'white' }} />,
          label: 'Comics',
          onClick: () => navigate('/dashboard/comics'),
        },
        {
          key: 'genres',
          icon: <AiOutlineTags style={{ color: 'white' }} />,
          label: 'Genres',
          onClick: () => navigate('/dashboard/genres'),
        }
      ]
    },
    {
      key: 'user',
      label: <span style={{ color: 'white', fontSize: 16 }}>User</span>,
      icon: <AiOutlineUser style={{ color: 'white', fontSize: 20 }} />,
      children: [
        {
          key: 'users',
          icon: <FiUsers style={{ color: 'white' }} />,
          label: 'Users',
          onClick: () => navigate('/dashboard/users'),
        },
      ]
    },
    {
      key: 'settings',
      label: <span style={{ color: 'white', fontSize: 16 }}>Settings</span>,
      icon: <FiSettings style={{ color: 'white', fontSize: 20 }} />,
      onClick: () => navigate('/dashboard/settings')
    }
  ];

  return (
    <Sider collapsed={siderCollapsed} style={{ backgroundColor: adjustColor(themeColor, -20) }}>
      <Menu
        mode="inline"
        theme="dark"
        items={items}
        style={{ backgroundColor: adjustColor(themeColor, -20) }}
      />
      <div style={{ ...styles.btnToggleSider, width: siderCollapsed ? 80 : 200 }} onClick={toggleSider}>
        {siderCollapsed
          ? <TbLayoutSidebarRightCollapse style={{ color: 'white', fontSize: 20 }} />
          : <TbLayoutSidebarLeftCollapse style={{ color: 'white', fontSize: 20 }} />
        }
      </div>
      {/* <div style={{ ...styles.btnAdd, width: siderCollapsed ? 80 : 200 }}>
        {siderCollapsed
          ?
          <PlusOutlined style={{ color: 'white', fontSize: 20 }} />
          :
          <span style={{ color: 'white', fontWeight: 'bold', fontSize: 16 }}>ADD NEW</span>
        }
      </div> */}
    </Sider>
  )
}

const styles = {
  btnToggleSider: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    cursor: 'pointer',
    position: 'absolute',
    bottom: 0,
    transition: 'all .2s',
  },
  // btnAdd: {
  //   position: 'absolute',
  //   bottom: 0,
  //   height: 48,
  //   backgroundColor: '#28a745',
  //   cursor: 'pointer',
  //   transition: 'all .2s',
  //   display: 'flex',
  //   borderRadius: 5,
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   marginBottom: 10,
  // }
};

export default CustomSider;